// Centralized social media preview data
import { menuImages } from './menu';

// Thumbnail versions of images for social preview grids
const DD_THUMB = 'https://img.cdn4dd.com/cdn-cgi/image/fit=contain,width=300,height=300,format=auto/https://doordash-static.s3.amazonaws.com/media/photosV2';

export const instagramPreviewImages = [
  `${DD_THUMB}/e848a58e-c05f-4116-b34d-aca3338c9f06-retina-large.jpg`,
  `${DD_THUMB}/7f0723bf-93ad-44b6-8951-f2ee9f46b6e0-retina-large.jpg`,
  `${DD_THUMB}/f8acbb56-ec81-4d38-8f5b-60bd4c1eb9d0-retina-large.jpg`,
  `${DD_THUMB}/cd4a3f7a-4ed7-4743-9c60-d8302b6f5746-retina-large.jpg`,
  `${DD_THUMB}/a79e2033-6f0e-4cd8-bf7e-e9fffc4c6e9d-retina-large.jpg`,
  `${DD_THUMB}/6c3ce9dc-b08a-49a8-82af-b61af8fc524f-retina-large.jpg`,
];

export const facebookPreviewImage = 'https://img.cdn4dd.com/cdn-cgi/image/fit=contain,width=600,height=400,format=auto/https://doordash-static.s3.amazonaws.com/media/photosV2/ea3e388f-b595-4674-87b6-9adeeab8b0bb-retina-large.jpg';
